import { createSelector } from "reselect";
import moment from "moment";
import zip from "lodash/zip";

const batteryDataSelector = state => state.chartData.data.battery;
const pMaxDataSelector = state => state.chartData.data.pMax;
const meterWithSelector = state => state.chartData.data.meter_with_bess;
const meterWithoutSelector = state => state.chartData.data.meter_without_bess;

const reshapeDataCSV = (batteryData, meterWithData, meterWithoutData, pMaxData) => {
  const data = [[], [], [], [], [], []];
  let CSVData = [...data];
  meterWithData.forEach(item => {
    CSVData[0].push(moment(item.timestamp).format("DD/MM/YYYY HH:mm:ss"));
    CSVData[1].push(item.p);
  });

  meterWithoutData.forEach(item => CSVData[2].push(item.p));

  batteryData.forEach(item => {
    CSVData[3].push(item.soc);
    CSVData[4].push(item.p);
  });

  let currentPmax = pMaxData[0];
  meterWithData.forEach(({ timestamp }) => {
    if(timestamp) {
      if(timestamp <= currentPmax.timestamp) {
        CSVData[5].push(currentPmax.value);
      } else {
        const currentIndex = pMaxData.indexOf(currentPmax);
        if(currentIndex < pMaxData.length -1) {
          currentPmax = pMaxData[currentIndex + 1];
          CSVData[5].push(currentPmax.value);
        }
      }
    }
  });

  const zippedData = zip(...CSVData);
  CSVData = [
    [
      "DateTime",
      "Load (kW)",
      "Load Without BESS (kW)",
      "Battery SOC",
      "Battery Power (kW)",
      "Pmax (kW)"
    ],
    ...zippedData
  ];

  CSVData.splice(1, 1);

  return CSVData;
};

export default createSelector(
  batteryDataSelector,
  meterWithSelector,
  meterWithoutSelector,
  pMaxDataSelector,
  reshapeDataCSV
);



// WEBPACK FOOTER //
// ./src/selectors/reshape_data_for_csv.js